import BaseInput from "@/components/reusables/BaseInput";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ProductType } from "../../../types";

type SupplierProductCodeFieldProps = {
    editing?: boolean;
};

export default function SupplierProductCodeField({
    editing = false,
}: SupplierProductCodeFieldProps) {
    const { t } = useTranslation("", { keyPrefix: "products.general" });

    const { control } = useFormContext<ProductType>();

    return (
        <Controller
            name="supplier_product_code"
            control={control}
            render={({ field, fieldState }) => (
                <BaseInput
                    {...field}
                    error={fieldState.error}
                    label={t("fields.supplierProductCode")}
                />
            )}
        />
    );
}
